<template>
    <div>
        <component :is="templateName" v-bind="$attrs"></component>
    </div>
</template>

<script>
import PieceCode from './PieceCode.vue';

export default {
    name: 'XxTagTemplate',
    components: {
        PieceCode,
    },
    props: {
        // 模板名
        templateName: {
            type: String,
            required: true
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
